import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { createHeadline, Headline } from '@vfde-brix/ws10/headline';
import { HtmlId } from '../enum';
import { createComponentById } from '@vfde-brix/ws10/core';

/**
 * Create Brix Headline component.
 * @param {HtmlId} id - ID of the element.
 * @param {string=} content - text to show
 * @returns {Headline | null} component or null if element with given id is not found
 */
export const mountHeadline = (id: HtmlId, content?: string) => {
    const comp = createComponentById(createHeadline, id, NO_PATTERN_BUSINESS_LOGIC);

    if (content) {
        comp?.update({ stdContent: content });
    }

    return comp;
};

/**
 * Update Headline component
 * @param {Headline | null} comp - Headline component or null
 * @param {string=} stdContent - the new content
 */
export const updateHeadline = (comp: Headline | null, stdContent?: string) => comp?.update({ stdContent });
